<template>
  <div :is="tagName" :class="_classNames">
    <slot></slot>
  </div>
</template>

<script>
export default {
    name: "BsCardContent",
    props: {
        /**
         * Override html tag generated by `type` property.
         * @type {string|*}
         */
        tag: {
            type: String,
            default: undefined
        },
        /**
         * Card content variations, valid values are: `title`, `subtitle`, `text`.
         * @type {string|*}
         */
        type: {
            type: String,
            default: 'text',
            validator(value) {
                return ['title', 'subtitle', 'text'].indexOf(value) > -1;
            }
        }
    },
    computed: {
        _classNames() {
            return {
                ['card-' + this.type]: this.tagName
            }
        },
        tagName() {
            if (!this.tag) {
                return (this.type === 'title' ? 'h4' : this.type === 'subtitle' ? 'h5' : 'p');
            }
            return this.tag;
        }
    }
}
</script>

<style scoped>

</style>
